export const VALIDATION_ERROR_KEYS = {
  entityRelations: 'entity_relations',
  workflowValidation: 'workflow_validation',
  deletionConstraints: 'deletion_constraints',
  lifecycleHook: 'lifecycle_hook'
} as const;

/**
 * Error-bag keys the generic {@link GlobalValidationErrorModal} owns: they name no form field, so
 * no input can render them, and their message is already a finished sentence for the user. Adding
 * a key here is all it takes for a new server-side rejection of this shape to reach a modal on
 * every transport.
 */
export const MODAL_VALIDATION_ERROR_KEYS = [VALIDATION_ERROR_KEYS.lifecycleHook] as const;

/**
 * Error-bag keys that name no form field and are surfaced by a global handler (a dedicated modal
 * or the generic one) rather than by an input. Anything rendering an error bag should skip them so
 * the message is not shown twice, the second time labelled with its raw key.
 */
export const GLOBALLY_HANDLED_VALIDATION_ERROR_KEYS = [
  VALIDATION_ERROR_KEYS.entityRelations,
  VALIDATION_ERROR_KEYS.workflowValidation,
  VALIDATION_ERROR_KEYS.deletionConstraints,
  ...MODAL_VALIDATION_ERROR_KEYS
] as const;
